import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import type { Position } from '@core/http-types';
import { injectReportsHttpApiService } from '@core/reports-contracts';
import type {
  ReportDashboard,
  ReportDashboardApiEntity,
  ReportDashboardComponentGridPosition,
  ReportsDashboardCreate,
  ReportsDashboardsHttpClientService,
} from '@core/reports-types';

export abstract class ReportsDashboardsHttpClientBase
  implements ReportsDashboardsHttpClientService
{
  private readonly http = injectReportsHttpApiService();

  public fetchCollection(): Observable<{ dashboards: ReportDashboardApiEntity[] }> {
    return this.http.get<{ dashboards: ReportDashboardApiEntity[] }>('/dashboards');
  }

  public fetchOne(id: number): Observable<{ dashboard: ReportDashboardApiEntity }> {
    return this.http.get<{ dashboard: ReportDashboardApiEntity }>(`/dashboards/${id}`);
  }

  public createOne(
    dashboardToCreate: ReportsDashboardCreate,
  ): Observable<{ dashboard: ReportDashboardApiEntity }> {
    throw new Error('Method not implemented.');
  }

  public updateOne(
    dashboard: Partial<ReportDashboard>,
  ): Observable<{ dashboard: ReportDashboardApiEntity }> {
    throw new Error('Method not implemented.');
  }

  public updatePositions(
    changes: Position[],
  ): Observable<{ dashboards: ReportDashboardApiEntity[] }> {
    throw new Error('Method not implemented.');
  }

  public removeOne(id: string | number): Observable<{ dashboard: { id: number } }> {
    throw new Error('Method not implemented.');
  }

  public moveComponent(
    componentId: number,
    sourceDashboardId: number,
    targetDashboardId: number,
    grid: ReportDashboardComponentGridPosition,
  ): Observable<void> {
    throw new Error('Method not implemented.');
  }
}

@Injectable()
export class ReportsDashboardsHttpClient
  extends ReportsDashboardsHttpClientBase
  implements ReportsDashboardsHttpClientService {}
